// 团队列表
export const getGroupInfoList = function (params) {
  return this.$http('get', 'mall/group-info/pageList', params);
}
// 新增一级渠道查询接口
export const getPrimaryChannelPageList = function (params) {
  return this.$http('get', 'mall/group-info/primaryChannelPageList', params);
}

// 报单二级渠道账户查询
export const getSecondaryChannelPageList = function (params) {
  return this.$http('get', 'mall/group-info/secondaryChannelPageList', params);
}

// 添加成员
export const saveAccount = function (data) {
  return this.$http('post', 'mall/account/saveAccount', data);
}
// 修改
export const editAccount = function (data) {
  return this.$http('post', 'mall/account/editAccount', data);
}

// 修改状态
export const setTeamAccountStatus = function (accountId) {
  return this.$http('post', `mall/account/closeAccount?accountId=${accountId}`, {});
}

// 筛选账号
export const douyinM2SPageList = function (params) {
  return this.$http('get', 'mall/group-info/douyinM2SPageList', params);
}

// 渠道分页查询（名称/手机号模糊搜索）
export const channelPageList = function (params) {
  return this.$http('get', 'mall/group-info/channelPageList', params);
}

// 批量修改bd
export const batchUpdateBd = function (data) {
  return this.$http('post', `mall/account/batchUpdateBd`, data);
}
